<template>
  <div>
    <mdb-row>
      <mdb-col md="2">
        <student-list :init-student='initStudent' :training="training._id" v-model="student"/>
      </mdb-col>
      <mdb-col md="10" v-if="student._id && training && training._id">
        <staff-student-basic-info :student="student" class="mb-3"/>
        <staff-test-summary-per-student v-if="student && student._id" :student="student._id"/>
      </mdb-col>
    </mdb-row>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import StudentList from '../../../components/common/StudentList.vue';
import StaffTestSummaryPerStudent from '../../../components/summary/StaffTestSummaryPerStudent.vue';
import StaffStudentBasicInfo from './StaffStudentBasicInfo.vue';
import StaffTestByStudent from './StaffTestByStudent.vue'
export default {
  name: 'StaffTestSummaryByStudent',
  // components: { StaffTestByStudent, StudentList, StaffStudentBasicInfo },
  components: { StudentList, StaffStudentBasicInfo, StaffTestSummaryPerStudent },
  props: [],
  data: () => ({
    initStudent: '',
    student: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training']),
    ...mapGetters('auth', ['isTeacher', 'isStaff'])
  },
  methods: {
    async load () {
      // 초기화
      this.initStudent = this.$route.query.student
    },
    onActiveTab (index) {
    }
  },
  watch: {
    training () {
      // this.initStudent = {}
      // this.student = {}
      // this.$router.replace({ name: this.$route.name })
    },
    student () {
      if (!this.student) return
      if (this.$route.query.student !== this.student._id) {
        this.$router.push({ path: '', query: { student: this.student._id } })
      }
    }
  },
  created () { this.load() }
}
</script>
